import HomePage from "../pages/HomePage";
import SalesPage from "../pages/SalesPage/SalesPage";
// import ProductsPage from "../pages/ProductsPage";
// import ChatsPage from "../pages/ChatsPage";
import WebsitesPage from "../pages/WebsitesPage";
// import CenterPage from "../pages/CenterPage";
// import MetricsPage from "../pages/MetricsPage";
// import CalculatorPage from "../pages/CalculatorPage";
// import SavedProjectionsPage from "../pages/SavedProjectionsPage";
// import LearningPage from "../pages/LearningPage";
import SettingsPage from "../pages/SettingsPage";
import LogInPage from "../pages/LogInPage";
// import SignUpPage from "../pages/SignUpPage";
// import PlansPage from "../pages/PlansPage";
// import PaymentPage from "../pages/PaymentPage";
import CancelPage from "../pages/CancelPage";
import SuccessPage from "../pages/SuccessPage";
import WebsitesBuilderIFramePage from "../pages/WebsiteBuilderIframePage";
// import ManageSubsctiptionPage from "../pages/ManageSubscriptionPage";
import LandingPage from "../pages/LandingPage";
import PaymentMethodPage from "../pages/PaymentMethodPage";
import OnboardingPage from "../pages/FunnelCreationPage";
import { OrderDetailsPage } from "../pages/OrderDetailsPage/OrderDetailsPage";
import ProductsPage from "../pages/productPage/productPage";
import AdsPage from "../pages/AdsPage/AdsPage";
import AnalyticsPage from "../pages/AnaliticsPage/AnalyticsPage";
import OnboardingFakePage from "../pages/FunnelCreationFakePage";
import { MembershipPage } from "../pages/membershipsPage/MembershipsPage";
import { PlansPage } from "../pages/Plans/PlansPage";
import { IntegrationsPage } from "../pages/Integrations/IntegrationsPage";
import LandingOfferPage from "../pages/LandingOfferPage";
import { OnboardingLayoutHome } from "../components/onboardingHome/OnboardingLayoutHome";
import { OnboardingLayoutHomeDemo } from "../components/onboardingHome1/OnboardingLayoutHomeDemo";
import SentryTestPage from "../components/SentryTestPage";

export const protectedRoutes = [
  // { path: "/", element: <LandingPage /> },
  { path: "/home", element: <HomePage /> },

  { path: "/orders", element: <SalesPage /> },
  { path: "/order/:hash_id", element: <OrderDetailsPage /> },
  { path: "/products", element: <ProductsPage  /> },
  // { path: "/chats", element: <ChatsPage /> },
  { path: "/funnels", element: <WebsitesPage /> },
  // { path: "/website/builder/:uuid", element: <WebsitesBuilderIFramePage /> },
  // { path: "/center", element: <CenterPage /> },
  // { path: "/metrics", element: <MetricsPage /> },
  // { path: "/calculator", element: <CalculatorPage /> },
  // { path: "/calculator/history", element: <SavedProjectionsPage /> },
  // { path: "/learning", element: <LearningPage /> },
  { path: "/settings", element: <SettingsPage /> },
  // { path: "/plans", element: <PlansPage /> },
  // { path: "/plans/checkout", element: <PaymentPage /> },
  // { path: "/cancel", element: <CancelPage /> },
  // { path: "/success", element: <SuccessPage /> },
  // { path: "/manage/subscription", element: <ManageSubsctiptionPage /> },
  { path: "/payment-methods", element: <PaymentMethodPage /> },
  { path: "/onboarding", element: <OnboardingPage /> },
  { path: "/onboarding1", element: <OnboardingFakePage /> },
  // { path: "/warehouse/create", element: <CreateWarehousePage /> },
  { path: "/ads", element: <AdsPage /> },
  { path: "/analytics/:website_id", element: <AnalyticsPage /> },
  { path: "/membership", element: <MembershipPage /> },
  { path: "/plans", element: <PlansPage /> },
  { path: "/integrations", element: <IntegrationsPage /> },
  { path: "/onboarding/home", element: <OnboardingLayoutHome /> },
  { path: "/onboarding1/home1", element: <OnboardingLayoutHomeDemo /> },

  { path: "/sentry-test", element: <SentryTestPage /> },
];

export const publicRoutes = [
  { path: "/", element: <LandingPage /> },
  { path: "/login", element: <LogInPage /> },
  // { path: "/signup", element: <SignUpPage /> },
  { path: "/payment-subscription/cancel", element: <CancelPage /> },
  { path: "/payment-subscription/success", element: <SuccessPage /> },
  { path: "/website/builder/guest", element: <WebsitesBuilderIFramePage /> },
  { path: "/login/offer", element: <LandingOfferPage /> },
];
